<div class="mt-6 w-full flex flex-col gap-5">
  <p-toast></p-toast>

  <p-card>
    <ng-template #title>
      <h1>
        {{ 'label.defects' | translate }}
      </h1>
    </ng-template>
    <div class="flex justify-end gap-2 mb-5">
      <p-button
        (click)="navigateToCreate()"
        [label]="'defect.add' | translate"
      />
    </div>

    <p-table
      #defectsTable
      [value]="defectService.defects()"
      stripedRows
      showGridlines
      dataKey="id"
      [resizableColumns]="true"
      columnResizeMode="expand"
      [paginator]="true"
      [rows]="25"
      [rowsPerPageOptions]="[25, 50, 75, 100]"
      sortField="reporting_time"
      [sortOrder]="-1"
      [scrollable]="true"
      [loading]="false"
      [tableStyle]="{ 'min-width': '50rem' }"
      [globalFilterFields]="globalFilterFields"
      [filters]="defaultFilters"
    >
      <ng-template #header>
        <tr>
          @for (column of defectColumns; track $index) {
            <th [pSortableColumn]="column.field" pResizableColumn>
              {{ column.header | translate }}
              @if (column.sortField) {
                <p-sortIcon [field]="column.sortField" />
              }
              @if (column.filterField) {
                @if (column.matchMode === 'in') {
                  <p-columnFilter
                    [field]="column.filterField"
                    matchMode="in"
                    display="menu"
                    [showOperator]="false"
                    [showMatchModes]="column.showMatchModes || false"
                    [showAddButton]="false"
                    [matchModeOptions]="
                      column.showMatchModes ? statusMatchModeOptions : undefined
                    "
                  >
                    <ng-template #filter let-value let-filter="filterCallback">
                      <p-multiselect
                        [ngModel]="value"
                        [options]="filterOptions()[column.field]"
                        (onChange)="filter($event.value)"
                        optionLabel="label"
                        optionValue="value"
                        [maxSelectedLabels]="1"
                        class="w-full"
                        appendTo="body"
                      />
                    </ng-template>
                  </p-columnFilter>
                } @else if (column.matchMode === 'between') {
                  <p-columnFilter
                    [field]="column.filterField"
                    matchMode="between"
                    display="menu"
                    [showOperator]="false"
                    [showMatchModes]="false"
                    [showAddButton]="false"
                  >
                    <ng-template #filter let-value let-filter="filterCallback">
                      <p-datepicker
                        [ngModel]="value"
                        (ngModelChange)="filter($event)"
                        selectionMode="range"
                        dateFormat="dd.mm.yy"
                        [readonlyInput]="true"
                        appendTo="body"
                      />
                    </ng-template>
                  </p-columnFilter>
                } @else {
                  <p-columnFilter
                    [field]="column.filterField"
                    display="menu"
                    [type]="column.type"
                    [matchMode]="column.matchMode"
                    [showOperator]="column.showOperator || false"
                    [showMatchModes]="column.showMatchModes || false"
                    [showAddButton]="column.showAddButton || false"
                  ></p-columnFilter>
                }
              }
            </th>
          }
          <th pFrozenColumn alignFrozen="right"></th>
        </tr>
      </ng-template>
      <ng-template #body let-defect>
        <tr class="cursor-pointer" (click)="navigateToDetail(defect)">
          @for (column of defectColumns; track $index) {
            @switch (column.field) {
              @case ('reporting_time') {
                <td>{{ defect.reporting_time | date: 'dd.MM.yyyy HH:mm' : 'Europe/Berlin' }}</td>
              }
              @case ('due_date') {
                <td>{{ defect.due_date | date: 'dd.MM.yyyy' : 'Europe/Berlin' }}</td>
              }
              @case ('status') {
                <td>
                  <p-tag
                    [value]="getStatusLabel(defect.status)"
                    [severity]="getStatusSeverity(defect.status)"
                  />
                </td>
              }
              @case ('model_type') {
                <td>{{ getTypeLabel(defect.model_type) }}</td>
              }
              @case ('priority') {
                <td>
                  @if (defect.priority) {
                    <p-tag
                      [value]="getPriorityLabel(defect.priority)"
                      [severity]="getPrioritySeverity(defect.priority)"
                    />
                  }
                </td>
              }
              @default {
                <td>{{ defect[column.field] }}</td>
              }
            }
          }
          <td pFrozenColumn alignFrozen="right">
            <div class="flex items-center justify-start gap-2">
              <button
                pButton
                type="button"
                icon="fa fa-pencil"
                (click)="navigateToDetail(defect); $event.stopPropagation()"
                text
                rounded
                severity="secondary"
              ></button>
              <button
                pButton
                type="button"
                icon="fa fa-trash"
                (click)="
                  onRowDeleteInit($event, defect); $event.stopPropagation()
                "
                text
                rounded
                severity="secondary"
              ></button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <p-confirmdialog />
  </p-card>
</div>
